// Field defs used by MMCollection to translate filters for Drupal `api/bins` / `api/bins/small`.
// Not a JsonApiModel and not used for HTTP.
export const binDrupalFilterFields = {
	created: { type: Date, default: () => new Date() },
	changed: { type: Date, default: () => new Date() },
	last_measurement: { type: Date, default: null },
	first_measurement: { type: Date, default: null },
	custom_id: { type: String, default: '' },
	assigned_id: { type: String, default: '' },
	title: { type: String, default: '' },
	active: { type: Boolean, default: true },
	volume: { type: Number, default: 0 },
	lid_size: { type: Number, default: 0 },
	remark: { type: String, default: '' },
	post_code: { type: String, default: '' },
	city: { type: String, default: '' },
	street: { type: String, default: '' },
	latitude: { type: Number, default: null },
	longitude: { type: Number, default: null },
	bin_type: { referenceType: 'taxonomy_term--bin_types' },
	location_type: { referenceType: 'taxonomy_term--bin_location_types' },
	surface: { referenceType: 'taxonomy_term--bin_surfaces' },
	material: { referenceType: 'taxonomy_term--bin_materials' },
	color: { referenceType: 'taxonomy_term--bin_colors' },
	emptying_frequency: { referenceType: 'taxonomy_term--bin_emptying_frequencies' },
	bin_damage: { referenceType: 'taxonomy_term--measurement_damage_amounts' },
	required_action: { referenceType: 'taxonomy_term--bin_action' },
};

export default function binDrupalFilterParent() {
	return { fields: binDrupalFilterFields };
}
